import { render } from "./CountriesView.vue?vue&type=template&id=06f1d789"
import script from "./CountriesView.vue?vue&type=script&lang=js"
export * from "./CountriesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__